module.exports = __webpack_public_path__ + "static/media/flag09.ea92a998.svg";